import { useEffect, useRef } from "react";
import {
  useAccountFetchOrders,
  useAccountState,
} from "@made-people/grease-account";
import { useHref } from "@made-people/grease-link";
import { useTranslate } from "@made-people/grease-translations";
import { LinkAsLink } from "@made-people/blueprint-link";
import { Heading } from "@made-people/blueprint-heading";
import { RecentOrderCard } from "./RecentOrderCard";

const RECENT_ORDERS_COUNT = 3;

export const RecentOrders = () => {
  const account = useAccountState();
  const orderFetcher = useAccountFetchOrders();
  const ordersFetched = useRef(false);
  const href = useHref();
  const translate = useTranslate();

  const ordersLoaded = account.orders !== undefined;

  useEffect(() => {
    if (!ordersFetched.current && !ordersLoaded) {
      ordersFetched.current = true;
      orderFetcher.execute();
    }
  }, [orderFetcher, ordersLoaded]);

  if (account.orders === undefined) return null;
  if (account.orders.length === 0) return null;

  const recentOrders = account.orders.slice(0, RECENT_ORDERS_COUNT);

  return (
    <section className="flex flex-col gap-4">
      <Heading
        heading={translate("Account_Overview_RecentOrders_Heading")}
        headingTag="h2"
        variants={{ headingSize: "sm" }}
      />
      <div className="flex gap-3 overflow-x-auto pb-2 -mx-4 px-4 lg:-mx-4">
        {recentOrders.map((order) => (
          <RecentOrderCard
            key={order.orderNumber}
            order={order}
            viewOrderHref={href(
              `comfort-club?route=orders&orderNumber=${order.orderNumber}`,
            )}
          />
        ))}
      </div>
      <LinkAsLink
        label={translate("Account_Overview_SeeAllOrders")}
        link={{ href: href("comfort-club?route=orders") }}
        variants={{ style: "underline" }}
        className="text-label-md -mt-1"
      />
    </section>
  );
};
